<!-- Подтверждает проверку заказ-наряда ремонта текущим пользователем. -->
<template>
  <BaseModal
    :visible="true"
    title="Фиксация проверки"
    size="md"
    footer-align="start"
    elevated-footer
    :close-on-escape="false"
    @close="$emit('close')"
  >
    <FleetRepairInspectionForm
      :repair-id="repairId"
      :form-id="formId"
      @confirmed="handleConfirmed"
    />

    <template #footer>
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="isSubmitting"
      >
        <span v-if="isSubmitting">Фиксация...</span>
        <span v-else>Зафиксировать</span>
      </base-primary-button>
      <base-button
        type="button"
        :disabled="isSubmitting"
        @click="$emit('close')"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import { mapState } from "pinia";

import { useFleetRepairStore } from "@/stores/fleetRepairStore";

import FleetRepairInspectionForm from "@/components/Fleet/Repair/InspectionForm.vue";

export default {
  name: "FleetRepairInspectionModal",

  components: {
    FleetRepairInspectionForm,
  },

  props: {
    repairId: {
      type: Number,
      required: true,
    },
  },

  emits: ["close", "confirmed"],

  computed: {
    ...mapState(useFleetRepairStore, ["isSubmitting"]),

    formId() {
      return "fleet-repair-inspection-form";
    },
  },

  methods: {
    handleConfirmed(repair) {
      this.$emit("confirmed", repair);
      this.$emit("close");
    },
  },
};
</script>
